import { render } from "./DbAccessForm.vue?vue&type=template&id=e9aabd66"
import script from "./DbAccessForm.vue?vue&type=script&lang=js"
export * from "./DbAccessForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__